import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// ✅ Define Product type (same as your store/api structure)
export interface ProductItem {
  id: number | string;
  title: string;
  slug?: string;
  price?: number | string;
  delPrice?: number | string;
  proImg?: string;
  brand?: string;
  stock?: string;
  size?: string;
}

// ✅ Props type
interface ProductProps {
  item: ProductItem;
  addToCart: (product: ProductItem) => void;
}

const Product: React.FC<ProductProps> = ({ item, addToCart }) => {
  return (
    <div className="row">
      {/* 🖼 Product Image Section */}
      <div className="col col-lg-5 col-12">
        <div className="shop-single-slider">
          <div className="slider-nav">
            <div>
              <Zoom>
                <img
                  src={item.proImg ?? ""}
                  alt={item.title || "Product Image"}
                />
              </Zoom>
            </div>
          </div>
        </div>
      </div>

      {/* 🛍 Product Info Section */}
      <div className="col col-lg-7 col-12">
        <div className="product-details">
          <h2>{item.title}</h2>

          {/* ⭐ Rating */}
          <div className="product-rt">
            <div className="rating">
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star-o"></i>
            </div>
            <span>(25 customer reviews)</span>
          </div>

          {/* 💲 Pricing */}
          <div className="price">
            <span className="current">${item.price}</span>
            <span className="old">${item.delPrice}</span>
          </div>

          {/* 📜 Description */}
          <p>
            Make your special day truly unforgettable with our exquisite Wedding
            Collection, thoughtfully designed to bring timeless beauty,
            romance, and sophistication to every moment. From breathtaking décor
            accents and floral arrangements to carefully handcrafted
            accessories, every detail reflects love, joy, and elegance.
          </p>

          {/* ✅ Features */}
          <ul>
            <li>Going through the cities of the world in classical style.</li>
            <li>There are many variations of passages.</li>
            <li>Making it look like readable and spoken English.</li>
          </ul>

          {/* 🛒 Add to Cart */}
          <div className="product-option">
            <div className="product-row">
              <button
                className="theme-btn"
                onClick={() => addToCart(item)}
                type="button"
              >
                Add to cart
              </button>
            </div>
          </div>

          {/* 📂 Extra Info */}
          <div className="tg-btm">
            <p>
              <span>Categories:</span> Ornaments
            </p>
            <p>
              <span>Tags:</span> Jewellery, Events, Wedding
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
